import HelpSvg from '../../../assets/help.svg?react';
import { IconProps } from '../../types/IconProps';

export function Help({ size = 20, ...props }: IconProps) {
  return <HelpSvg data-testid="help-icon" width={size} height={size} {...props} />;
}

export default Help;
